// Session-level cache for message board responses
export const messageBoardCache = new Map<string, any>();

export function buildMessageBoardCacheKey(params: Record<string, any>): string {
  return JSON.stringify(params, Object.keys(params).sort());
}

export function getMessageBoardCache(key: string): any | undefined {
  return messageBoardCache.get(key);
}

export function setMessageBoardCache(key: string, data: any): void {
  messageBoardCache.set(key, data);
}

export function clearMessageBoardCache() {
  messageBoardCache.clear();
}
